import { PureComponent } from 'react'
import {
  Button,
  FormLabel,
  Grid,
  ListItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableRow,
  Tooltip,
} from '@material-ui/core'
import React from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import MenuItem from '@material-ui/core/MenuItem'

class QuickBookSyncErrorLogs extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      page: 1,
      rowsPerPage: 10,
    }
  }

  handleChangePage = (page, count) => (event) => {
    if (count >= 1 && count <= Math.ceil(this.props.errorLogs.total / this.state.rowsPerPage)) {
      this.setState({
        page: count,
      })
      this.props.apiCall(this.props.reference, (count - 1) * 10, this.state.rowsPerPage)
    }
    this.forceUpdate()
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value })
    this.forceUpdate()
    this.props.apiCall(this.props.reference, (this.state.page - 1) * 10, event.target.value)
  }

  render() {
    const pages = Math.ceil(this.props.errorLogs.total / this.state.rowsPerPage)
    let page = this.state.page
    return (
      <div>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Paper className="margin-top-small">
            {this.props.errorLogs &&
            this.props.errorLogs.values &&
            this.props.errorLogs.values.length > 0 ? (
              <div className="table-scroll">
                <div>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Entity</TableCell>
                        <TableCell>Sync Time</TableCell>
                        <TableCell>QB Status Code</TableCell>
                        <TableCell>Description</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {this.props.errorLogs.values.map((log, index) => {
                        return (
                          <TableRow>
                            <TableCell>{log.quickBookEntityType}</TableCell>
                            <TableCell>
                              {moment(log.errorTime).format('hh:mmA')}{' '}
                              {moment(log.errorTime).format('MM/DD/YYYY')}
                            </TableCell>
                            <TableCell>{log.statusCode}</TableCell>
                            <TableCell>{log.description}</TableCell>
                          </TableRow>
                        )
                      })}
                    </TableBody>
                    <TableFooter>
                      <TableRow>
                        <TableCell colSpan={5}>
                          <ul className="pagination">
                            <li>Rows per page</li>
                            <li>
                              <Select
                                value={this.state.rowsPerPage}
                                onChange={this.handleChangeRowsPerPage.bind(this)}
                              >
                                <MenuItem value={10}>10</MenuItem>
                                <MenuItem value={20}>20</MenuItem>
                                <MenuItem value={30}>30</MenuItem>
                              </Select>
                            </li>
                            <li>
                              {this.state.page} of {pages}
                            </li>
                            <li>
                              <Tooltip title="Previous" aria-label="Previous">
                                <Button onClick={this.handleChangePage('prv', page - 1)}>
                                  <i className="material-icons">chevron_left</i>
                                </Button>
                              </Tooltip>
                            </li>
                            <li>
                              <Tooltip title="Next" aria-label="Next">
                                <Button onClick={this.handleChangePage('next', page + 1)}>
                                  <i className="material-icons">chevron_right</i>
                                </Button>
                              </Tooltip>
                            </li>
                          </ul>
                        </TableCell>
                      </TableRow>
                    </TableFooter>
                  </Table>
                </div>
              </div>
            ) : (
              <ListItem>
                <FormLabel component="legend">
                  Unfortunately, detailed logs couldn't be recorded.
                </FormLabel>
              </ListItem>
            )}
          </Paper>
        </Grid>
      </div>
    )
  }
}

export default connect((state) => ({ dispatch: state.dispatch }))(QuickBookSyncErrorLogs)



// WEBPACK FOOTER //
// ./src/components/QuickBook/QuickBookSyncErrorLogs.js